import { ReduceStore } from 'flux/utils';
import { Map } from 'immutable';
import AppDispatcher from '../AppDispatcher';
import Constants from '../Constants';

// helper function to make uplift scores not choke everything if it's not present
function parseUpliftScore(scenario) {
  if (scenario.relationships.upliftScores.data) {
    return scenario.relationships.upliftScores.data.id;
  }
  return null;
}

function parseSubsetUniverse(scenario) {
  if (scenario.relationships.targetListSubsetUniverse.data) {
    return scenario.relationships.targetListSubsetUniverse.data.id;
  }
  return null;
}

// remove trailing timestamp, underscores, capitalize first letter of everything
// Used in conjunction with the search filter in the index
function shapeName(name) {
  const reportkeyRegexp = new RegExp(/__TK\d{8}T\d{6}_\d{3}Z$/, '');
  const underscoreRegexp = new RegExp(/_/, 'g');
  return name.replace(reportkeyRegexp, '')
             .replace(underscoreRegexp, ' ')
             .toLowerCase()
             .replace(/(^| )(\w)/g, s => s.toUpperCase());
}

export function shapeScenarioForLoad(scenario) {
  const cleanScenario = [scenario.id,
    {
      id: scenario.id,
      parameters: {
        runName: shapeName(scenario.attributes.name),
        targetUniverse: scenario.relationships.targetUniverse.data.id,
        upliftScore: parseUpliftScore(scenario),
        totalBudget: scenario.attributes.parameters.totalBudget,
        jobDiscount: scenario.attributes.parameters.crossChannelDiscountFactor,
        targetListSubsetMode: scenario.attributes.parameters.targetListSubsetMode,
        targetListSubsetUniverse: parseSubsetUniverse(scenario),
        modes: scenario.attributes.parameters.modes,
      },
      name: shapeName(scenario.attributes.name),
      tableauReportKey: `cc_${scenario.attributes.name}`,
      organizationId: +scenario.relationships.organization.data.id,
      runs: scenario.relationships.runs.data,
    }];

  return cleanScenario;
}

class CrossChannelScenarioStore extends ReduceStore {
  getInitialState() {
    return new Map();
  }

  reduce(state, action) {
    switch (action.actionType) {
      case Constants.CrossChannel.SCENARIOS_RECEIVED:
        return this.getState()
          .merge(new Map(action.scenarios.map(shapeScenarioForLoad)));
      case Constants.CrossChannel.SCENARIO_DESTROYED:
        return this.getState()
          .filter(scenario => scenario.id !== action.scenarioId);
      default:
        return state;
    }
  }

  getScenarios() {
    return this.getState();
  }

  // getScenario(scenarioId) {
    // return this.getState().filter(scenario => scenario.id === scenarioId);
  // }
}

const instance = new CrossChannelScenarioStore(AppDispatcher);
export default instance;
